import React from 'react';
import { KivlopeLogo } from '../components/Icons';

const InfoScreen = ({ onBack }) => {
    return (
        <div className="min-h-screen bg-[#121212] text-[#EAEAEA] font-sans">
            {/* Header */}
            <header className="p-4 flex justify-between items-center border-b border-gray-800 bg-[#1E1E1E]">
                <div className="flex items-center cursor-pointer" onClick={onBack}>
                    <KivlopeLogo size={40} />
                    <h1 className="text-2xl font-bold text-[#D4AF37] ml-3 font-serif">kivlope</h1>
                </div>
                <button
                    onClick={onBack}
                    className="text-[#A0A0A0] hover:text-white transition-colors"
                >
                    Back
                </button>
            </header>

            <main className="max-w-4xl mx-auto p-6 space-y-12 animate-fade-in">

                {/* About Section */}
                <section>
                    <h2 className="text-3xl font-bold text-[#D4AF37] mb-4">About kivlope</h2>
                    <p className="text-lg leading-relaxed text-gray-300">
                        kivlope is a digital time capsule designed to help you preserve moments, messages, and memories for the future.
                        Unlike instant messaging, kivlope allows you to "seal" your messages (Kivs) so they can only be opened at a specific time you choose.
                        Whether it's a prediction for next year, a birthday wish sent months in advance, or a memory to revisit in a decade, kivlope ensures it arrives exactly when it means the most.
                    </p>
                </section>

                {/* Use Cases Section */}
                <section>
                    <h2 className="text-3xl font-bold text-[#D4AF37] mb-6">Ways to Use kivlope</h2>
                    <div className="grid md:grid-cols-3 gap-6">
                        <div className="bg-[#1E1E1E] p-6 rounded-xl border border-gray-800">
                            <h3 className="text-xl font-bold text-white mb-2">Future Messages</h3>
                            <p className="text-gray-400">Send a birthday video to your best friend scheduled for next year, or write a letter to your child to open on their 18th birthday.</p>
                        </div>
                        <div className="bg-[#1E1E1E] p-6 rounded-xl border border-gray-800">
                            <h3 className="text-xl font-bold text-white mb-2">Predictions</h3>
                            <p className="text-gray-400">Lock in your predictions for sports, elections, or personal goals and prove you called it when the time comes.</p>
                        </div>
                        <div className="bg-[#1E1E1E] p-6 rounded-xl border border-gray-800">
                            <h3 className="text-xl font-bold text-white mb-2">Digital Legacy</h3>
                            <p className="text-gray-400">Leave behind stories, advice, and love for your family to discover gradually over time.</p>
                        </div>
                    </div>
                </section>

                {/* FAQ Section */}
                <section>
                    <h2 className="text-3xl font-bold text-[#D4AF37] mb-6">Frequently Asked Questions</h2>
                    <div className="space-y-6">
                        <div>
                            <h3 className="text-xl font-bold text-white mb-2">Can I open a Kiv before the unlock date?</h3>
                            <p className="text-gray-400">No. Once a Kiv is sealed, it remains locked until the scheduled date. This ensures the integrity of the time capsule experience.</p>
                        </div>
                        <div>
                            <h3 className="text-xl font-bold text-white mb-2">Is it free?</h3>
                            <p className="text-gray-400">Yes, Kivlope is free to use for sending and receiving standard text and image Kivs.</p>
                        </div>
                        <div>
                            <h3 className="text-xl font-bold text-white mb-2">Is my data secure?</h3>
                            <p className="text-gray-400">Absolutely. We use industry-standard encryption to ensure your memories are safe until they are ready to be revealed.</p>
                        </div>
                    </div>
                </section>

            </main>

            {/* Footer */}
            <footer className="p-8 text-center text-gray-600 mt-12 border-t border-gray-800">
                <p>&copy; {new Date().getFullYear()} kivlope. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default InfoScreen;
